import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { AlertModule } from 'ngx-bootstrap/alert';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RatingModule } from 'ngx-bootstrap/rating';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './components/search/search.component';
import { DefaultComponent } from './components/default/default.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ModalContentComponent } from './components/search/search.component';
import { ConsolidatedModalContentComponent } from './components/search/search.component';
import { SignupComponent } from './components/signup/signup.component';
import {AddSourceComponent} from './components/datasource/addsource.component'
import { SourcesComponent} from './components/datasource/sources.component'


import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { IndexPipe } from '../app/pipes/index.pipe';
import { SafePipe } from '../app/pipes/safe.pipe';
import {UserService} from './servies/user/user.service';
import { ExcelService } from './servies/export_xls/excel-export';
import { RssFeedComponent } from './components/rss-feed/rss-feed.component';
import { HeaderComponent } from './header/header.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SearchHistoryComponent } from './components/search/search-history/search-history.component';
import {Ng5SliderModule } from 'ng5-slider';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import {DatePipe} from '@angular/common';
// for Http import LoadingBarHttpModule:
// import { LoadingBarHttpModule } from '@ngx-loading-bar/http';

// for Router import LoadingBarRouterModule:
// import { LoadingBarRouterModule } from '@ngx-loading-bar/router';


@NgModule({
  entryComponents: [
      ModalContentComponent,
      ConsolidatedModalContentComponent
  ],
  declarations: [
    AppComponent,
    ModalContentComponent,
    ConsolidatedModalContentComponent,
    SafePipe,
    SearchComponent,
    DefaultComponent,
    PageNotFoundComponent,
    IndexPipe,
    RssFeedComponent,
    SignupComponent,
    HeaderComponent,  
    AddSourceComponent,
    SearchHistoryComponent,  
    SourcesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,

    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AlertModule.forRoot(),
    PaginationModule.forRoot(),
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    RatingModule.forRoot(),
    MDBBootstrapModule.forRoot(),

    LoadingBarHttpClientModule,
    CollapseModule.forRoot(),
    BrowserAnimationsModule,
    AccordionModule.forRoot(),   
    Ng2SearchPipeModule,
    Ng5SliderModule,
    Ng4LoadingSpinnerModule.forRoot()
    
      // for Http use:
    // LoadingBarHttpModule,

    // for Router use:
    // LoadingBarRouterModule

    // for HttpClient use:
    // LoadingBarHttpClientModule
  ],
  providers: [UserService,ExcelService,DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
